import React, { forwardRef, useEffect, useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { translate as t } from 'hooks/useTranslations';
import { Add } from '@mui/icons-material';
import Choice from './Choice';
import { CRQChoice } from 'views/App/Portal/Policy/_types/crq';
import { ManualContent } from 'views/App/Portal/Policy/_types/manuals/draft';

type ChoicesInputProps = {
  id: string;
  manualContent: ManualContent[];
  value: CRQChoice[] | undefined;
  onChange: (choices: CRQChoice[]) => void;
};

const ChoicesInput = forwardRef(({ id, manualContent, value, onChange }: ChoicesInputProps, ref) => {
  const getItems = (value: CRQChoice[] | undefined) => {
    let initialItems = [...(value || [])];
    if (!initialItems || initialItems.length === 0)
      return [
        { value: '', content: [] },
        { value: '', content: [] },
      ];
    if (initialItems.length === 1) return [...initialItems, { value: '', content: [] }];
    initialItems = initialItems.map((x) => ({ ...x, id: uuidv4() }));
    return initialItems;
  };
  const [items, setItems] = useState<CRQChoice[]>([]);

  const handleInputChange = (index: number, choice: CRQChoice) => {
    const newItems = [...items];
    newItems[index] = { value: choice.value.trim(), content: choice.content } as CRQChoice;
    setItems(newItems);
    console.log('handleInputChange', newItems);
    onChange(newItems);
  };

  const handleAddItem = () => {
    const newItems = [...items, { value: `Option ${items.length + 1}`, content: [], id: uuidv4() } as CRQChoice];
    setItems(newItems);
    onChange(newItems);
  };

  const handleRemoveItem = (index: number) => {
    const newItems = [...items];
    newItems.splice(index, 1);
    if (newItems.length < 2) newItems.push({ value: '', content: [] });
    setItems(newItems);
    onChange(newItems);
  };

  useEffect(() => {
    setItems(getItems(value));
  }, [value]);

  return (
    <Box
      id={id}
      key={id}
      sx={{
        display: 'grid',
        gap: 3,
      }}
    >
      {items.map((item, index) => (
        <Choice
          key={item.id}
          choice={item}
          handleItemChange={(newValue) => handleInputChange(index, newValue)}
          handleRemoveItem={() => handleRemoveItem(index)}
          manualContent={manualContent}
        />
      ))}
      <Stack
        direction='row'
        key='addOption'
      >
        <Button
          variant='text'
          color='neutral'
          onClick={handleAddItem}
          startIcon={<Add />}
          size='small'
        >
          {t('draftManuals.crq.properties.addOption')}
        </Button>
      </Stack>
    </Box>
  );
});

export default ChoicesInput;
